<template>
  <v-container fluid class="salesrep-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-options`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-cog</v-icon>
            Options
          </v-tab>
          <v-tab
            :href="`#tab-commission`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-cash</v-icon>
            Commision
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-area`"
          >
            <v-icon class="mr-3">mdi-map-clock</v-icon>
            Area
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-visit`"
          >
            <v-icon class="mr-3">mdi-store-clock</v-icon>
            Visit
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-map`"
          >
            <v-icon class="mr-3">mdi-map</v-icon>
            Map
          </v-tab>
          <v-tab-item
            :value="'tab-options'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">Edit Options</p>
                      <v-text-field
                        readonly
                        class="mb-4"
                        outlined
                        dense
                        v-bind:value="initvalue.username"
                        placeholder="Name"
                        persistent-hint
                        single-line hint="Name">
                      </v-text-field>
                      <v-text-field
                        type="number"
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeOptions($event, 'creditLimit')"
                        v-bind:value="initvalue.options!=null ? initvalue.options.creditLimit: ''"
                        placeholder="Limit"
                        persistent-hint
                        single-line hint="Enter credit limit">
                      </v-text-field>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/salesrep/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editOptionsRequest()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-commission'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">Edit Commission</p>
                      <v-text-field
                        readonly
                        class="mb-4"
                        outlined
                        dense
                        v-bind:value="initvalue.username"
                        placeholder="Name"
                        persistent-hint
                        single-line hint="Name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeCommission($event, 'rate')"
                        v-bind:value="initvalue.commission!=null ? initvalue.commission.rate : 0"
                        placeholder="Rate"
                        persistent-hint
                        single-line hint="Enter commission rate">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeCommission($event, 'threshold')"
                        v-bind:value="initvalue.commission.threshold"
                        placeholder="Threshold"
                        persistent-hint
                        single-line hint="Enter sales threshold">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeCommission($event, 'limit')"
                        v-bind:value="initvalue.commission.limit"
                        placeholder="Limit"
                        persistent-hint
                        single-line hint="Enter commission limit">
                      </v-text-field>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/salesrep/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editCommissionRequest()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-area'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Sales Rep Areas</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddArea = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="arearank"
                        :headers="areaHeaders"
                        :items="repareas"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteArea" width="500">
                            <v-card>
                              <v-card-title> Delete this Area? </v-card-title>
                              <v-card-text>
                                {{ delete_area.areadesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteArea = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteRepArea(delete_area)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.areadesc="{ item }">
                          <p class="two-line">{{ item.areadesc }}</p>
                          <p class="two-line">{{ item.areadesc2 }}</p>
                        </template>
                        <template v-slot:item.townshipid="{ item }">
                          <p class="two-line" v-if="item.regionid">{{ regions.length>0 ? regions.find(region=>region._id==item.regionid)['regionname'] : '' }}</p>
                          <p class="two-line" v-if="item.townshipid">{{ townships.length>0 ? townships.find(township=>township._id==item.townshipid)['townshipname'] : '' }}</p>
                          <p class="two-line" v-if="item.districtid">{{ districts.length>0 ? districts.find(district=>district._id==item.districtid)['districtname'] : '' }}</p>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editRouteAreaDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteRepAreaDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/salesrep/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-visit'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Sales Rep Visits</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddVisit=true; search_customer={}"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :sort-by="['daynum', 'visitnum']"
                        :headers="visitHeaders"
                        :items="repvisits"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteVisit" width="500">
                            <v-card>
                              <v-card-title> Delete this Visit? </v-card-title>
                              <v-card-text>
                                {{ delete_visit.visitname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteVisit = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteRepVisit(delete_visit)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.visitname="{ item }">
                          <p class="two-line">{{ item.visitname }}</p>
                        </template>
                        <template v-slot:item.visitimage="{ item }">
                            <img v-if="item.visitimage" v-bind:src="item.visitimage" alt="" width="80">
                        </template>
                        <template v-slot:item.townshipid="{ item }">
                          <p class="two-line">{{ item.regionid!=undefined && regions.find(region=>region._id == item.regionid)!=null ? regions.find(region=>region._id == item.regionid)['regionname'] : ''   }}</p>
                          <p class="two-line">{{ item.townshipid!=undefined && townships.find(township=>township._id == item.townshipid)!=null ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
                          <a class="primaryConst--text" target="_blank" v-bind:href="'http://maps.google.com/maps?q=' + item.geolocation.replace(' ', '')">Map</a>
                        </template>                   
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editRepVisitDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteRepVisitDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/salesrep/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-map'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row >
                  <v-col cols="12" md="1">
                    <span class="text-h5" style="padding:10px">Map</span>
                  </v-col>
                  
                  <v-col cols="12" md="1">
                    <v-select
                      class="mb-4"
                      :items="['All'].concat(Array.from({ length: 30 }, (value, index) => (index+1).toString()))"
                      v-model="map_daynum"
                      v-on:change="findGeolocations($event)"
                      placeholder="Day"
                      dense
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col>
                    <div class="mapContainer" v-bind:style="geolocations.length>0 ? 'height: 700px' : 'height: 50px'">
                      <GmapMap v-if="geolocations.length>0"
                        :center="{lat: median.lat, lng: median.lng}"
                        :zoom="12"
                        style="width: 100%; height: inherit"
                      >
                      <GmapMarker
                          v-for="(location, index) in geolocations"  
                          :key="index"
                          :position="{lat: parseFloat(location.lat), lng: parseFloat(location.lng)}"
                          :label="location.visitnum.toString()"
                          :clickable="true"
                          :draggable="false"
                          :icon= "getIcon(location)"
                          @click="openInfoWindowTemplate(location)"
                      />
                        <gmap-info-window
                            :options="{
                              maxWidth: 300,
                              pixelOffset: { width: 0, height: -35 }
                            }"
                            :position="infoWindow.position"
                            :opened="infoWindow.open"
                            @closeclick="infoWindow.open=false">
                            <div v-html="infoWindow.template"></div>
                        </gmap-info-window>
                        
                      </GmapMap>
                    </div>
                  </v-col>                  
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/salesrep/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row justify="center">
    <v-dialog
      v-model="isAddArea"
      persistent
      width="1000px"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Area</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_area.daynum"
                  class="mb-4"
                  placeholder="Day"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Day"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="add_area.areadesc"
                  label="Description"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="add_area.areadesc2"
                  label="Description Other"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="regions.map(x => {
                    return {text: x.regionname, value: x._id};
                  })"
                  v-model="add_area.regionid"
                  v-bind:error="errorindex == 3"
                  placeholder="Region"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="townships.filter(x=>x.regionid==add_area.regionid).map(x => {
                    return {text: x.townshipname, value: x._id};
                  })"
                  v-model="add_area.townshipid"
                  v-bind:error="errorindex == 3"
                  placeholder="Township"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="districts.filter(x=>x.townshipid==add_area.townshipid).map(x => {
                    return {text: x.districtname, value: x._id};
                  })"
                  v-model="add_area.districtid"
                  placeholder="District"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch
                  color="primary"
                  v-model="add_area.isHalfDay"
                  value="Inactive"
                  label="Half Day"
                  :true-value=true
                  :false-value=false
                  dense
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddArea=false; add_area={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addRepAreaRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddVisit"
      persistent
      scrollable
      width="75%"
    >
      <v-card>
        <v-card-title>
          <v-container>
            <v-row >
              <v-col cols="12" md="2">
                <span class="text-h5" style="padding:10px">Add Visit</span>
              </v-col>
              <v-col cols="12" md="3">  
                <v-select
                  class="mb-4"
                  :items="regions.map(x => {
                    return {text: x.regionname, value: x._id};
                  })"
                  v-model="search_customer.regionid"
                  v-bind:error="errorindex == 3"
                  placeholder="Region"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  class="mb-4"
                  :items="townships.filter(x=>x.regionid==search_customer.regionid).map(x => {
                    return {text: x.townshipname, value: x._id};
                  })"
                  v-model="search_customer.townshipid"
                  v-on:change="filterCustomers"
                  v-bind:error="errorindex == 3"
                  placeholder="Township"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="1">
                <v-btn
                  small
                  class="button-shadow"
                  color="primary"
                  @click="findCustomers"
                >
                  Find
                </v-btn>
              </v-col>
              <v-col cols="12" md="1"></v-col>
              <v-col cols="12" md="1">
                <v-select
                  class="mb-4"
                  :items="Array.from({ length: 30 }, (value, index) => index+1)"
                  v-model="search_customer.daynum"
                  placeholder="Day"
                  dense
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="1">
                <v-select
                  class="mb-4"
                  :items="Array.from({ length: 15 }, (value, index) => index+1)"
                  v-model="search_customer.visitnum"
                  placeholder="Num"
                  dense
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-title>
        <v-card-text style="height: 700px;">
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-data-table
                  :items-per-page="100"
                  :headers="customerHeaders"
                  :items="customers"
                  item-value="name"
                  :footer-props="footer"
                  :loading="isLoading"
                >
                <template v-slot:item.customerimage="{ item }">
                  <img v-if="item.customerimage" v-bind:src="item.customerimage" alt="" width="80">
                </template>
                <template v-slot:item.customername="{ item }">
                  <a class="primaryConst--text">{{ item.customername }}</a>
                  <p style="margin-top: 0; margin-bottom: 0;">{{ item.customertype }}</p>
                </template>
                <template v-slot:item.customeraddress="{ item }">
                  <a class="primaryConst--text">{{ item.customeraddress }}</a>
                  <p style="margin-top: 0; margin-bottom: 0;">{{ item.customerphone  }}</p>
                  <p style="margin-top: 0; margin-bottom: 0;">{{ item.customermobile  }}</p>
                </template>
                <template v-slot:item.townshipid="{ item }">
                  <p style="margin-top: 0; margin-bottom: 0;">{{ item.regionid!=undefined && regions.find(region=>region._id == item.regionid)!=null ? regions.find(region=>region._id == item.regionid)['regionname'] : ''   }}</p>
                  <p style="margin-top: 0; margin-bottom: 0;">{{ item.townshipid!=undefined && townships.find(township=>township._id == item.townshipid)!=null ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
                </template>
                <template v-slot:item.customerstatus="{ item }">
                  <v-chip
                    :color="!item.customerstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                    small>
                    {{ item.customerstatus }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div v-if="isVisitCustomer(item)==false">
                  <v-btn icon color="primary" @click="addRepVisitRequest(item)">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  </div>
                </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddVisit = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditArea"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Area</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeArea($event, 'daynum')"
                  :value="edit_area.daynum"
                  class="mb-4"
                  placeholder="Day"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Day"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  v-on:change="onChangeArea($event, 'areadesc')"
                  :value="edit_area.areadesc"
                  label="Description"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  v-on:change="onChangeArea($event, 'areadesc2')"
                  :value="edit_area.areadesc2"
                  label="Description Other"
                  required
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="regions.map(x => {
                    return {text: x.regionname, value: x._id};
                  })"
                  v-model="edit_area.regionid"
                  v-on:change="onChangeArea($event, 'regionid')"
                  :value="edit_area.regionid"
                  v-bind:error="errorindex == 3"
                  placeholder="Region"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="townships.filter(x=>x.regionid==edit_area.regionid).map(x => {
                    return {text: x.townshipname, value: x._id};
                  })"
                  v-model="edit_area.townshipid"
                  v-on:change="onChangeArea($event, 'townshipid')"
                  :value="edit_area.townshipid"
                  v-bind:error="errorindex == 3"
                  placeholder="Township"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="districts.filter(x=>x.townshipid==edit_area.townshipid).map(x => {
                    return {text: x.districtname, value: x._id};
                  })"
                  v-model="edit_area.districtid"
                  v-on:change="onChangeArea($event, 'districtid')"
                  :value="edit_area.districtid"
                  placeholder="District"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch
                  color="primary"
                  v-model="edit_area.isHalfDay"
                  v-on:change="onChangeArea($event, 'isHalfDay')"
                  :value="edit_area.isHalfDay"
                  label="Half Day"
                  :true-value=true
                  :false-value=false
                  dense
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditArea = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editRepAreaRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditVisit"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Visit</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeVisit($event, 'daynum')"
                  :value="edit_visit.daynum"
                  class="mb-4"
                  placeholder="Day"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Day"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeVisit($event, 'visitnum')"
                  :value="edit_visit.visitnum"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  dense
                  v-on:change="onChangeVisit($event, 'visitname')"
                  :value="edit_visit.visitname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditVisit= false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editRepVisitRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      areaHeaders: [
        { text: "Day", value: "daynum", width: "20px" },
        { text: "Desc", value: "areadesc", width: "30%"},
        { text: "Area", value: "townshipid", width: "30%"},
        { text: "Half Day", value: "isHalfDay" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      customerHeaders: [
        { text: 'Image', value: 'customerimage', sortable: false },
        { text: 'Name', value: 'customername' },
        { text: 'Address', value: 'customeraddress' },
        { text: 'Location', value: 'townshipid' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      visitHeaders: [
        { text: "Day", value: "daynum", width: "20px" },
        { text: "Num", value: "visitnum", width: "20px" },
        { text: "Image", value: "visitimage" },
        { text: "Name", value: "visitname", width: "40%" },
        { text: "Location", value: "townshipid" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      itemHeaders: [
        { text: "#", value: "itemrank", width: "10px" },
        { text: "Area", value: "areaid" },
        { text: "Visit", value: "visitid" },
        { text: "Name & Code", value: "itemname" },
        { text: "Icon", value: "itemicon" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      searchtext: null,
      initvalue: {},
      commission: {},
      repareas: [],
      repvisits: [],
      geolocations: [],
      customers: [],
      median: {lat: 0, lng: 0},
      infoWindow: {
          position: {lat: 0, lng: 0},
          open: false,
          template: ''
      },
      error: undefined,
      haserror: false,
      errorindex: undefined,
      add_area: {},
      add_visit: {},
      edit_area: {},
      edit_visit: {},
      change_options: {},
      change_commission: {},
      change_area: {},
      change_visit: {},
      delete_area: {},
      delete_visit: {},
      search_customer: {},
      isDeleteArea: false,
      isDeleteVisit: false,
      isAddArea: false,
      isAddVisit: false,
      isEditArea: false,
      isEditVisit: false,
      map_daynum: null,
      isLoading: false,
      orange: 'http://maps.google.com/mapfiles/ms/icons/orange-dot.png',
      orange1: 'http://maps.google.com/mapfiles/ms/icons/orange.png',
      yellow: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
      yellow1: 'http://maps.google.com/mapfiles/ms/icons/yellow.png',
      green: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
      green1: 'http://maps.google.com/mapfiles/ms/icons/green.png',
      blue: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
      blue1: 'http://maps.google.com/mapfiles/ms/icons/blue.png',
      purple: 'http://maps.google.com/mapfiles/ms/icons/purple-dot.png',
      purple1: 'http://maps.google.com/mapfiles/ms/icons/purple.png',
      red: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
      red1: 'http://maps.google.com/mapfiles/ms/icons/red.png',
      pink: 'http://maps.google.com/mapfiles/ms/icons/pink-dot.png',
      pink1: 'http://maps.google.com/mapfiles/ms/icons/pink.png',
      ltblue: 'http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png',
      footer: {'items-per-page-options': [500, 1000, 5000]},
    }
  },
  computed: {
    ...mapState('Menu', ['isReceiving']),
    ...mapState('District', ['districts']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
  },
  methods: {
    ...mapActions('SalesRep', 
    [ 'getSalesRepsRequest',
      'deleteRepAreaRequest', 'deleteRepVisitRequest', 'deleteMenuItemRequest',
      'insertRepAreaRequest', 'insertRepVisitRequest',
      'updateSalesRepOptionsRequest','updateSalesRepCommissionRequest','updateRepAreaRequest','updateRepVisitRequest','updateMenuItemRequest' 
    ]),
    ...mapActions('Customer', ['findCustomersShortQueryRequest']),
    ...mapActions('District', ['getDistrictsRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('Township', ['getTownshipsRequest']),
    findMedian(){
      let lats = this.geolocations.map(location=>parseFloat(location.lat));
      let lngs = this.geolocations.map(location=>parseFloat(location.lng));
      lats.sort();
      lngs.sort();
      return {lat: lats[parseInt(lats.length/2)], lng: lngs[parseInt(lngs.length/2)]}
    },
    getIcon(item){
      let num = item.daynum;
      let icon = {url: null, scaledSize: {width: 45, height: 45}}


      console.log(num)
      if([1,15].includes(num)) icon.url = this.blue;
      else if([2,16].includes(num)) icon.url = this.red;
      else if([3,17].includes(num)) icon.url = this.orange;
      else if([4,18].includes(num)) icon.url = this.purple;
      else if([5,19].includes(num)) icon.url = this.pink;
      else if([6,20].includes(num)) icon.url = this.yellow;
      else if([7,21].includes(num)) icon.url = this.green;
      else if([8,22].includes(num)) icon.url = this.blue1;
      else if([9,23].includes(num)) icon.url = this.red1;
      else if([10,24].includes(num)) icon.url = this.orange1;
      else if([11,25].includes(num)) icon.url = this.purple1;
      else if([12,26].includes(num)) icon.url = this.pink1;
      else if([13,27].includes(num)) icon.url = this.yellow1;
      else if([14,28].includes(num)) icon.url = this.green1;
      else icon.url = this.ltblue;
      return icon;
    },
    openInfoWindowTemplate(item) {
      this.infoWindow.open = true;
      this.infoWindow.position = { lat: parseFloat(item.lat), lng: parseFloat(item.lng) }
      this.infoWindow.template = `<img src="${item.visitimage}" width="200">
                                  <p style="margin: 0"><b>${item.visitname}</b></p>
                                  <p style="margin: 0">Day: ${item.daynum} - Num: ${item.visitnum}</p>
                                  <br>`

      console.log(this.infoWindow);
      this.infoWindow.open = true
    },
    findGeolocations(){
      let results = [];
      let visits = this.map_daynum=='All' || this.map_daynum==null ? this.repvisits : this.repvisits.filter(x=>x.daynum== parseInt(this.map_daynum) );
      for(var i in visits){
        let visit = visits[i];
        let location = visit.geolocation.replace(" ", "");
        let lat = location.split(',')[0];
        let lng = location.split(',')[1];
        results.push({visitname: visit.visitname, visitimage: visit.visitimage, daynum: visit.daynum, visitnum: visit.visitnum, lat: lat, lng: lng });
      }
      this.geolocations = results;
      this.median = this.findMedian();
      return results;
    },
    
    async addRepAreaRequest() {
      this.isAddArea = false;
      this.add_area.userid = this.initvalue._id;
      let result = await this.insertRepAreaRequest(this.add_area);
      this.repareas.push(result);
      this.add_area = {};
    },
    async addRepVisitRequest(item) {
      this.add_visit.userid = this.initvalue._id;
      this.add_visit.daynum = this.search_customer.daynum;
      this.add_visit.visitnum = this.search_customer.visitnum;
      this.add_visit.customerid = item._id;
      this.add_visit.visitname = item.customername;
      this.add_visit.visitimage = item.customerimage;
      this.add_visit.regionid = item.regionid;
      this.add_visit.townshipid = item.townshipid;
      this.add_visit.geolocation = item.geolocation;
      let result = await this.insertRepVisitRequest(this.add_visit);
      this.repvisits.push(result);
      this.findGeolocations();
      this.add_visit = {};
    },
    isVisitCustomer(item){
      let result = this.repvisits.find(visit=>visit.customerid==item._id);
      if(result!=null) return true;
      return false;
    },
    deleteRepAreaDialog(item) {
      this.isDeleteArea = true;
      this.delete_area = {_id: item._id, areadesc: item.areadesc};
    },
    deleteRepVisitDialog(item) {
      this.isDeleteVisit = true;
      this.delete_visit = {_id: item._id,visitname: item.visitname};
    },
    async deleteRepArea(payload) {
      this.isDeleteArea = false;
      let response = await this.deleteRepAreaRequest(payload);
      let index = this.repareas.findIndex((trans) => trans._id == response._id);
      this.repareas.splice(index, 1);
    },
    async deleteRepVisit(payload) {
      this.isDeleteVisit = false;
      let response = await this.deleteRepVisitRequest(payload);
      let index = this.repvisits.findIndex((trans) => trans._id == response._id);
      this.repvisits.splice(index, 1);
      this.findGeolocations();
    },
    editRouteAreaDialog(item) {
      this.edit_area = Object.assign({}, item);
      this.change_area = {};
      this.isEditArea = true;
    },
    editRepVisitDialog(item) {
      this.edit_visit = Object.assign({}, item);
      this.change_visit = {};
      this.isEditVisit= true;
    },
    async editCommissionRequest() {
      this.change_commission._id = this.initvalue._id;
      await this.updateSalesRepCommissionRequest(this.change_commission);
      router.push('/salesrep/list');
    },
    async editOptionsRequest() {
      this.change_options._id = this.initvalue._id;
      await this.updateSalesRepOptionsRequest(this.change_options);
      router.push('/salesrep/list');
    },
    async editRepAreaRequest() {
      this.isEditArea = false;
      this.change_area.repareaid = this.edit_area._id;
      let response = await this.updateRepAreaRequest(this.change_area);
      let index = this.repareas.findIndex((x) => x._id == response._id);
      this.repareas.splice(index, 1, response);
      this.edit_area = {};
    },
    async editRepVisitRequest() {
      this.isEditVisit = false;
      this.change_visit.repvisitid = this.edit_visit._id;
      let response = await this.updateRepVisitRequest(this.change_visit);
      let index = this.repvisits.findIndex((x) => x._id == response._id);
      this.repvisits.splice(index, 1, response);
      this.findGeolocations();
      this.edit_visit = {};
    },    
    async findCustomers(){
      this.isLoading = true;
      this.customers = [];
      this.search_customer.userid = this.initvalue._id;
      console.log(this.search_customer);
      let result = await this.findCustomersShortQueryRequest(this.search_customer);
      this.customers = Object.assign([], result);
      this.isLoading = false;
    },
    async filterCustomers(){
      let results = this.initvalue.actives.filter(customer=>customer.townshipid==this.search_customer.townshipid);
      this.customers = Object.assign([], results);
    },
    onChangeCommission(value, field){
      this.change_commission[field] = value;
    },
    onChangeOptions(value, field){
      this.change_options[field] = value;
    },
    onChangeArea(value, field){
      this.change_area[field] = value;
    },
    onChangeVisit(value, field){
      this.change_visit[field] = value;
    },   
  },

  async created () {
    this.initvalue = this.$route.params;
    if(this.initvalue.commission==null) this.initvalue.commission = {};
    this.repareas = this.initvalue.areas;
    this.repvisits = this.initvalue.visits;
    this.customers = this.initvalue.actives;
    this.findGeolocations();
    if(!this.initvalue._id) this.$router.push({ name: 'SalesRepList' });
    if(this.districts.length==0) await this.getDistrictsRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();

  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
